<template>
    <div>
      <h2>作业打印</h2>
      <el-button @click="printHomework">打印作业</el-button>
      <el-button type="primary" @click="back">返回</el-button>
    </div>
  </template>

<script>
export default {
  name: 'PrintComponent',
  methods: {
    back() {
      this.$router.push('/homework')
    },
    printHomework() {
      window.print()
    }
  }
}
</script>

  <style scoped>
  </style>
